import { graphql } from "@/data-access/graphql";
import {
  KeyMessageGroupFragment,
  KeyMessageItemFragment,
} from "../fragments/key-message-fragments";

export const CreateKeyMessageGroup = graphql(
  `
    mutation createKeyMessageGroup($input: CreateKeyMessageGroupInput!) {
      createKeyMessageGroup(input: $input) {
        ... on KeyMessageGroupType {
          ...KeyMessageGroupFragment
        }
      }
    }
  `,
  [KeyMessageGroupFragment],
);

export const CreateKeyMessage = graphql(
  `
    mutation createKeyMessage($input: CreateKeyMessageItemInput!) {
      createKeyMessageItem(input: $input) {
        ... on KeyMessageItemType {
          ...KeyMessageItemFragment
        }
      }
    }
  `,
  [KeyMessageItemFragment],
);

export const GetKeyMessagesAndGroups = graphql(
  `
    query getKeyMessageAndGroups($filters: KeyMessageGroupByFeedFilter!) {
      keyMessageGroups(filters: $filters, ordering: { name: ASC }) {
        ...KeyMessageGroupFragment
        keyMessageItems {
          ...KeyMessageItemFragment
        }
      }
    }
  `,
  [KeyMessageGroupFragment, KeyMessageItemFragment],
);

export const GetKeyMessages = graphql(
  `
    query getKeyMessages($filters: FeedArticleProjectionFilter!) {
      keyMessageItemsV2(filters: $filters) {
        ...KeyMessageItemFragment
      }
    }
  `,
  [KeyMessageItemFragment],
);

export const UpdateKeyMessageGroup = graphql(
  `
    mutation updateKeyMessageGroup($input: UpdateKeyMessageGroupInput!) {
      updateKeyMessageGroup(input: $input) {
        ... on KeyMessageGroupType {
          ...KeyMessageGroupFragment
        }
      }
    }
  `,
  [KeyMessageGroupFragment],
);

export const UpdateKeyMessage = graphql(
  `
    mutation updateKeyMessage($input: UpdateKeyMessageItemInput!) {
      updateKeyMessageItem(input: $input) {
        ... on KeyMessageItemType {
          ...KeyMessageItemFragment
          feedId
        }
      }
    }
  `,
  [KeyMessageItemFragment],
);

export const DeleteKeyMessage = graphql(`
  mutation deleteKeyMessage($feedId: ID!, $itemId: ID!) {
    deleteKeyMessageItem(feedId: $feedId, itemId: $itemId) {
      ... on KeyMessageItemType {
        id
        group {
          id
        }
        __typename
      }
    }
  }
`);

export const DeleteKeyMessageGroup = graphql(`
  mutation deleteKeyMessageGroup($feedId: ID!, $groupId: ID!) {
    deleteKeyMessageGroup(feedId: $feedId, groupId: $groupId) {
      ... on KeyMessageGroupType {
        id
        __typename
      }
    }
  }
`);

export const MergeKeyMessageGroup = graphql(
  `
    mutation mergeKeyMessageGroup($feedId: ID!, $fromId: ID!, $toId: ID!) {
      mergeKeyMessageGroup(feedId: $feedId, fromId: $fromId, toId: $toId) {
        ... on KeyMessageGroupType {
          ...KeyMessageGroupFragment
        }
      }
    }
  `,
  [KeyMessageGroupFragment],
);

export const KeyMessageItemsSubscription = graphql(
  `
    subscription KeyMessageItems($filters: FeedArticleProjectionFilter!) {
      keyMessageItemV2(filters: $filters) {
        ...KeyMessageItemFragment
      }
    }
  `,
  [KeyMessageItemFragment],
);

export const GetKeyMessageGroupsForSegment = graphql(`
  query getKeyMessageGroupsForSegment($filters: KeyMessageGroupByFeedFilter!) {
    keyMessageGroups(filters: $filters) {
      id
      name
      keyMessageItems {
        id
        name
      }
    }
  }
`);

export const KeyMessageInsightsSubscription = graphql(`
  subscription KeyMessageInsights(
    $keyMessageId: ID!
    $projectionFilters: FeedArticleProjectionFilter
  ) {
    keyMessageInsights(
      keyMessageId: $keyMessageId
      projectionFilters: $projectionFilters
    ) {
      keyMessageId
      startDate
      endDate
      status
      metrics {
        key
        value
      }
      whatToKnow
      whyItMatters
    }
  }
`);

export type CreateKeyMessageGroupVariablesType = Parameters<
  Exclude<typeof CreateKeyMessageGroup.__apiType, undefined>
>[0];

export type CreateKeyMessageVariablesType = Parameters<
  Exclude<typeof CreateKeyMessage.__apiType, undefined>
>[0];

export type GetKeyMessagesAndGroupsVariablesType = Parameters<
  Exclude<typeof GetKeyMessagesAndGroups.__apiType, undefined>
>[0];

export type GetKeyMessagesVariablesType = Parameters<
  Exclude<typeof GetKeyMessages.__apiType, undefined>
>[0];

export type UpdateKeyMessageGroupVariablesType = Parameters<
  Exclude<typeof UpdateKeyMessageGroup.__apiType, undefined>
>[0];

export type UpdateKeyMessageVariablesType = Parameters<
  Exclude<typeof UpdateKeyMessage.__apiType, undefined>
>[0];

export type GetKeyMessageGroupsForSegmentVariablesType = Parameters<
  Exclude<typeof GetKeyMessageGroupsForSegment.__apiType, undefined>
>[0];

export type KeyMessageInsightUpdate = ReturnType<
  Exclude<typeof KeyMessageInsightsSubscription.__apiType, undefined>
>["keyMessageInsights"];
